import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Icon } from '@iconify/react'

import { Button } from '@/components/ui/button.jsx'
import { Input } from '@/components/ui/input.jsx'
import { Label } from '@/components/ui/label.jsx'
import { CircleLoader } from '@/components/loader/CircleLoader.jsx'

import OurAmazingLogo from '@/assets/logos/spring.png'

export const SharedReportPasswordGate = ({ onAuthenticate, isLoading, error }) => {

    const [password, setPassword] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        if (password.trim()) {
            onAuthenticate(password)
        }
    }

    return (
        <div className="min-h-screen bg-main-surface bg-center bg-cover bg-no-repeat flex items-center justify-center">
            <motion.div
                initial={{ opacity: 0, y: 20, scale: 0.95 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ duration: 0.4, ease: 'easeOut' }}
                className="w-full max-w-sm mx-auto p-8"
            >
                <motion.div
                    initial={{ opacity: 0, y: -8 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.15, duration: 0.3 }}
                    className="flex flex-col items-center mb-8"
                >
                    <img
                        src={OurAmazingLogo}
                        alt="upspring-ai-logo"
                        className="w-24 mb-4"
                    />
                    <h1 className="text-lg font-medium text-foreground">Shared Report</h1>
                    <p className="text-sm text-muted-foreground mt-1">
                        Enter the password to view this report
                    </p>
                </motion.div>

                <motion.form
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.25, duration: 0.3 }}
                    onSubmit={handleSubmit}
                    className="space-y-4"
                >
                    <div className="space-y-2">
                        <Label className="text-sm">Password</Label>
                        <Input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter password"
                            autoFocus
                            className="text-sm"
                        />
                    </div>

                    <AnimatePresence>
                        {error && (
                            <motion.p
                                initial={{ opacity: 0, x: -8 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -8 }}
                                transition={{ duration: 0.2 }}
                                className="text-xs text-destructive flex items-center gap-1.5"
                            >
                                <Icon icon="mdi:alert-circle" className="h-3.5 w-3.5" />
                                {error}
                            </motion.p>
                        )}
                    </AnimatePresence>

                    <Button
                        type="submit"
                        disabled={isLoading || !password.trim()}
                        className="w-full gap-2"
                    >
                        {isLoading ? (
                            <>
                                <CircleLoader className="h-4 w-4 animate-spin" />
                                Verifying...
                            </>
                        ) : (
                            <>
                                <Icon icon="mdi:lock-open" className="h-4 w-4" />
                                View Report
                            </>
                        )}
                    </Button>
                </motion.form>
            </motion.div>
        </div>
    )
}
